angular.module('gym.calendar').controller('ManageEventTypesModal', ["$scope", "$modalInstance", "$timeout", "EventTypes", function($scope, $modalInstance, $timeout, EventTypes) {
  var clearErrors, loadEventTypes;
  $scope.newType = {};
  loadEventTypes = function() {
    return EventTypes.getList({
      count: 500,
      include_inactive: 1
    }).then(function(types) {
      return $scope.types = _.sortBy(types, function(type) {
        return !type.active;
      });
    });
  };
  loadEventTypes();
  clearErrors = function() {
    $scope.error = void 0;
    return $scope.newType.errors = void 0;
  };
  $scope.ok = function() {
    return $modalInstance.close();
  };
  $scope.save = function(type) {
    clearErrors();
    return type.save({
      include_inactive: 1
    }).then(function() {
      return loadEventTypes();
    }, function(response) {
      return type.errors = response.data.errors;
    });
  };
  $scope.displayName = function(type) {
    if (type.active) {
      return type.name;
    } else {
      return `[Deactivated] ${type.name}`;
    }
  };
  $scope.reactivateType = function(type) {
    type.active = true;
    return $scope.save(type);
  };
  $scope.edit = function(type) {
    clearErrors();
    type._edit = true;
    return type.old_name = type.name;
  };
  $scope.reset = function(type) {
    clearErrors();
    type.name = type.old_name;
    type.old_name = void 0;
    type._edit = void 0;
    return type.errors = {};
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.create = function() {
    clearErrors();
    return EventTypes.post($scope.newType).then(function(type) {
      $scope.newType = {};
      return $scope.types.push(type);
    }, function(response) {
      return $scope.newType.errors = response.data.errors;
    });
  };
  return $scope.delete = function(type) {
    clearErrors();
    return type.remove().then(function() {
      return loadEventTypes();
    }, function(response) {
      return $scope.error = 'This type is in use and cannot be deleted at this time.';
    });
  };
}]);
